export default __webpack_public_path__ + "static/1-e721fc3ccce7e6ceab7c02018a634d9d.jpeg";